import { useEffect, useState } from "react";
import { Option } from "~/lib/constants";
import { cn } from "~/lib/utils";

import { ErrorProps, FormError } from ".";
import { UserLists } from "../shared/user-lists";

interface Props {
  label: string;
  title?: string;
  required?: boolean;
  errors?: ErrorProps;
  options?: Option[];
  value: Option[];
  onChange: (value: Option[] | []) => void;
  className?: string;
}

export default function FormInternalInput({
  label,
  title,
  errors,
  value,
  onChange,
  options,
  className,
}: Props) {
  const [selections, setSelections] = useState<Option[]>(value ?? []);

  useEffect(() => {
    onChange(selections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selections]);
  return (
    <div>
      <div className="space-y-12">
        <div className="w-full">
          <div className="pb-4">
            <span className="text-lg font-medium">{label}</span>
          </div>
          <div
            className={cn(
              "rounded-md border border-neutral-300 bg-white px-3 py-2.5",
              className,
            )}
          >
            <UserLists
              options={options as Option[]}
              title={title as string}
              selections={selections}
              setSelectedOptions={setSelections}
            />
          </div>
          <FormError error={errors?.error} message={errors?.message} />
        </div>
      </div>
    </div>
  );
}
